import { Controller } from "@hotwired/stimulus"

// Auto-dismissing flash toast. Hovering pauses the countdown so a toast
// you're reading doesn't vanish out from under you.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.resume()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  pause() {
    clearTimeout(this.timeout)
  }

  resume() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.element.classList.add("opacity-0", "translate-y-2")
    setTimeout(() => this.element.remove(), 300)
  }
}
